import React from 'react';

import { Box } from '@chakra-ui/react';
import ReviewerTypeTag from 'Deer/components/common/ReviewerTypeTag';
import { useSelector } from 'react-redux';
import { selectLoggedInEmployeeId } from 'selectors/loggedInEmployee';

import { AnonymousSmiley } from 'assets/assetsV1/iconComponents';

import { Avatar } from 'uiToolkitV1/Avatar';
import { ListItemComp } from 'uiToolkitV1/ListItemComp';

const ListItemLeftComp = (src) => () => (src ? <Avatar src={src} /> : <AnonymousSmiley boxSize="24px" />);

const ResponseEmpHeader = ({ src, displayName, peerType, providerType, employeeId }) => {
  const loggedInEmployeeId = useSelector(selectLoggedInEmployeeId);

  const isLoggedInEmployee = employeeId?.toString() === loggedInEmployeeId;

  return (
    <Box pt={2} pb={3} display="flex" justifyContent="space-between">
      <ListItemComp
        title={`${displayName} ${isLoggedInEmployee ? '(Me)' : ''}`}
        LeftComponent={ListItemLeftComp(src)}
        withoutBackground
      />

      {displayName !== 'Anonymous' && <ReviewerTypeTag peerType={peerType} providerType={providerType} />}
    </Box>
  );
};

export default ResponseEmpHeader;
